
<template>
	<div class="analysis">
		<div class="flex align-items-center mt-sm">
			<div class="front-line font-18 mr">稼动分析</div>
			<el-date-picker v-model="time" type="date" placeholder="选择日期" style="width:140px;" :picker-options="options" value-format="timestamp" :clearable="false" @change="fetchData()" />
		</div>

		<div v-loading="loading" class="mt-md">
			<el-row :gutter="30">
				<el-col :span="12">
					<div class="stat flex column">
						<div class="font-16">
							时间稼动率
						</div>
						<div v-if="stat.time_effectiveness != '-'" class="flex mt align-items-end">
							<span class="font-28 number text-bold">{{ stat.time_effectiveness }}</span>
							<span class="unit ml-sm">%</span>
						</div>
						<span v-else class="mt font-28 number text-bold">{{ stat.time_effectiveness }}</span>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="stat flex column">
						<div class="font-16">
							性能稼动率
						</div>
						<div v-if="stat.property_effectiveness != '-'" class="flex mt align-items-end">
							<span class="font-28 number text-bold">{{ stat.property_effectiveness }}</span>
							<span class="unit ml-sm">%</span>
						</div>
						<span v-else class="mt font-28 number text-bold">{{ stat.property_effectiveness }}</span>
					</div>
				</el-col>
			</el-row>
		</div>

		<div v-loading="loading" class="mt-md">
			<el-row :gutter="30">
				<el-col :span="12">
					<analysis-pie :equipid="equipid" :random="new_random" :offline="stat.offline_hour" :online="stat.standby_hour" :running="stat.running_hour" :alarm="stat.alarm_hour" />
				</el-col>
				<el-col :span="12">
					<div class="flex column justify-content-center" style="height: 250px;">
						<div class="flex align-items-center">
							<div class="round offline" />
							<div class="ml-sm">
								停机时长：{{ stat.offline_hour_f }}
							</div>
						</div>
						<div class="flex align-items-center mt-lg">
							<div class="round online" />
							<div class="ml-sm">
								待机时长：{{ stat.standby_hour_f }}
							</div>
						</div>
						<div class="flex align-items-center mt-lg">
							<div class="round running" />
							<div class="ml-sm">
								运行时长：{{ stat.running_hour_f }}
							</div>
						</div>
						<div class="flex align-items-center mt-lg">
							<div class="round alarm" />
							<div class="ml-sm">
								告警时长：{{ stat.alarm_hour_f }}
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>

		<div class="mt-md">
			<analysis-bar :equipid="equipid" :random="new_random" :list="list" />
		</div>
	</div>
</template>

<script>
import { equipAnalysisApi } from '@/api/em/detailApi'
import { formatSecond } from '@/utils/common'

const nowDate = parseInt((new Date().getTime() / 1000).toString())
const yesterday = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24
const last90 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24 * 90

export default {
	components: {
		AnalysisPie: () => import('./AnalysisPie'),
		AnalysisBar: () => import('./AnalysisBar')
	},

	props: {
		equipid: {
			type: Number,
			default () {
				return 0
			}
		},

		random: {
			type: [Number, String],
			default: 0
		},
	},

	data () {
		var disabledDate = (date) => {
			if (this.disablerange) {
				if (this.disablerange.length === 1) {
					return date.getTime() < this.disablerange[0] * 1000
				} else {
					return date.getTime() < this.disablerange[0] * 1000 || date.getTime() > this.disablerange[1] * 1000
				}
			} else {
				return false
			}
		}
		return {
			loading: false,
			time: new Date(yesterday * 1000),
			options: {
				disabledDate: disabledDate
			},
			disablerange: [last90, yesterday],

			stat: {},
			list: [],

			new_random: ''
		}
	},

	watch: {
		random: function (newVal, oval) {
			this.time = new Date(yesterday * 1000)
			if (this.equipid) this.fetchData()
		}
	},

	created () {
		if (this.equipid) this.fetchData()
	},

	methods: {
		fetchData () {
			this.loading = true
			const temp = {
				equipid: this.equipid,
				time: this.time / 1000
			}
			equipAnalysisApi(temp).then(res => {
				this.loading = false
				if (!res.errno) {
					this.new_random = this.equipid + '-' + (+new Date())
					this.stat = Object.assign({}, res.data)
					this.stat.offline_hour_f = formatSecond(this.stat.offline_hour)
					this.stat.standby_hour_f = formatSecond(this.stat.standby_hour)
					this.stat.running_hour_f = formatSecond(this.stat.running_hour)
					this.stat.alarm_hour_f = formatSecond(this.stat.alarm_hour)
					this.list = this.stat.equip_status
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.analysis {
	width: 100%;
	.stat {
		height: 120px;
		width: 100%;
		background: #f8f9fc;
		padding: 20px;
		border-radius: 4px;
		.unit {
			line-height: 24px;
		}
	}
	.round {
		width: 16px;
		height: 16px;
		border-radius: 50%;
		flex-shrink: 0;
		&.offline {
			background: #999999;
			box-shadow: 0 0 5px #999999;
		}
		&.online {
			background: #e6a23c;
			box-shadow: 0 0 5px #e6a23c;
		}
		&.running {
			background: #f56c6c;
			box-shadow: 0 0 5px #f56c6c;
		}
		&.alarm {
			background: #07c160;
			box-shadow: 0 0 5px #07c160;
		}
	}
}
</style>
